export default {
  // 获取格式化的视频时长
  getFormattingDuration(hour, minute, second) {
    const totalMins = hour * 60 + minute;
    return `${this.alignTime(totalMins)} : ${this.alignTime(second)}`;
  },

  // 对齐分秒
  alignTime(num) {
    return num < 10 ? "0" + num : num;
  },

  // 格式化时间，补零
  formatSecond(seconds) {
    let second = parseInt(seconds);
    let minute = 0;
    let hour = 0;
    if (seconds > 60) {
      minute = parseInt(second / 60);
      second = parseInt(second % 60);
      if (minute > 60) {
        hour = parseInt(minute / 60);
        minute = parseInt(minute % 60);
      }
    }
    return {
      hour,
      minute,
      second
    };
  },

  // 格式化日期
  // 统一格式化：YYYY-MM-DD HH:mm:ss
  formatDate(date, type = "datetime", separator = "/") {
    if (!date) return date;
    if (typeof date === "string") {
      if (!date.trim()) {
        return date;
      }
      // IE 下不支持 YYYY-MM-DD 连接符的格式，需转成 /
      date = new Date(date.replace(/-/g, "/").replace("T", " "));
    } else {
      date = new Date(date); // 格式化时间戳（注意根据后台数据看需不需要乘以1000）
    }

    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    hour = hour < 10 ? "0" + hour : hour;
    minute = minute < 10 ? "0" + minute : minute;
    second = second < 10 ? "0" + second : second;
    if (type === "date") {
      return `${year}${separator}${month}${separator}${day}`;
    } else if (type === "datetime") {
      return `${year}${separator}${month}${separator}${day} ${hour}:${minute}:${second}`;
    } else if (type === "time") {
      return `${hour}:${minute}:${second}`;
    } else return date;
  },

  formatDate2(date, format = "yyyy-MM-dd HH:mm:ss") {
    date = new Date(date.replace(/-/g, "/").replace("T", " "));
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();

    let obj = {
      yyyy: String(year).padStart(4, "0"), //年
      MM: String(month).padStart(2, "0"), //月
      dd: String(day).padStart(2, "0"), //日
      HH: String(hour).padStart(2, "0"), //小时
      mm: String(minute).padStart(2, "0"), //分
      ss: String(second).padStart(2, "0") //秒
    };
    let result = format;
    for (let key in obj) {
      let reg = new RegExp(key);
      result = result.replace(reg, obj[key]);
    }
    return result;
  },
  // 判断当前时间是否大于一年
  timeDifference(date1) {
    let date2 = new Date();
    let newYear = date1.getFullYear();
    let newMonth = date1.getMonth() + 12;
    if (newMonth >= 11) {
      newYear += 1;
      newMonth -= 11;
      date1.setFullYear(newYear);
      date1.setMonth(newMonth - 1);
    } else {
      date1.setFullYear(newYear);
      date1.setMonth(newMonth);
    }
    if (date1.getTime() >= date2.getTime()) {
      return true;
    } else {
      return false;
    }
  },
  // 转换为百分比
  transformPercentNumber(num, bit = 2) {
    const val = Number(num);
    if (Number.isNaN(val)) {
      return num;
    }
    return Number((val * 100).toFixed(bit));
  },

  // 固定小数点，不四舍五入。想要四舍五入，直接使用toFixed(bit)
  toDecimal(num, bit = 2) {
    let result = parseFloat(num);
    if (Number.isNaN(result)) {
      return result;
    }
    const temp = Math.pow(10, bit);
    result = Math.floor(num * temp) / temp;
    return result;
  },

  // 验证密码
  verifyPassword(password) {
    const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\W]{8,16}$/;
    return passwordReg.test(password);
  },
  // 验证邮箱
  verifyEmail(data) {
    // const emailReg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/;
    const emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/;
    return emailReg.test(data);
  },
  // 验证手机号码
  verifyMobile(data) {
    const mobileReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    return mobileReg.test(data);
  },
  // 验证用户名
  verifyUsername(data) {
    const usernameReg = /^[A-Za-z0-9]+$/;
    return usernameReg.test(data);
  },

  // 判断是否为ie浏览器
  isIE() {
    const userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
    const isIE = userAgent.includes("compatible") && userAgent.includes("MSIE"); // 判断是否IE<11浏览器
    const isIE11 =
      userAgent.includes("Trident") && userAgent.includes("rv:11.0");
    // var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否Edge浏览器
    if (isIE || isIE11) {
      return true;
    } else {
      return false;
    }
  },

  // 首字母大写
  upInitial(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },

  // 获取唯一ID
  getUniqueID(flag) {
    const id = `${new Date().getTime()}-${Math.random()
        .toString()
        .split(".")[1]
      }`;
    return flag ? `${flag}-${id}` : id;
  },

  // 格式化文件对象
  formatFileObj(file) {
    if (!file) {
      return;
    }
    const index = file.lastIndexOf(".");
    const suffix = file.substring(index, file.length);
    const name = file.substring(0, index);
    return {
      name,
      suffix
    };
  },
  // 修改直播rtmp、flv的资源路径
  changeSourceURL(url) {
    let [s1, token] = url.split("?");
    const source = s1.substring(s1.lastIndexOf("/")).replace("/", "&");
    const base = s1.substring(0, s1.lastIndexOf("/"));
    return base + "?" + token + source;
  }
};
